module.exports = __webpack_public_path__ + "static/media/boat.b9492c91.svg";